import classNames from "classnames";
import { RichText } from "components/RichTextWidget";
import { useRef } from "react";
import { Container, Icon, ImageLite, SwiperLayout } from "shared/components";
import { useViewMode } from "shared/contexts/ViewMode";
import { SwiperSlide } from "swiper/react";

import styles from "./Content022.module.scss";

export const Content022 = ({ payload }) => {
  const slider = payload?.slider ?? {};
  const sliderSize = payload?.sliderSize ?? "large";
  const backgroundColor = payload?.backgroundColor ?? "light";
  const backgroundPosition = payload?.backgroundPosition ?? "top";

  const { isMobile, isDesktop } = useViewMode();
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <div className={styles.wrapper}>
      <div
        className={classNames(
          styles[`${backgroundColor}`],
          styles[`${backgroundPosition}`]
        )}
      ></div>
      <Container
        className={classNames({
          [styles.inner]: sliderSize === "large",
        })}
      >
        <div className={styles.content}>
          <div className={styles.slider}>
            <SwiperLayout
              prevRef={prevRef}
              nextRef={nextRef}
              watchOverflow={false}
              slidesPerView={1}
              slidesPerGroup={1}
              loop={true}
              paginationWrapper={styles.pagination}
            >
              {slider.map((item) => (
                <SwiperSlide key={item.id} className={styles.slide}>
                  <ImageLite image={item.image} className={styles.image} />
                  <RichText
                    color={isMobile ? "dark" : "light"}
                    className={styles.description}
                    value={item.description}
                  />
                </SwiperSlide>
              ))}
            </SwiperLayout>
          </div>
          <div className={styles["navigation-wrapper"]}>
            <div className={styles["slider-navigation"]}>
              <div
                ref={prevRef}
                className={classNames(
                  styles.navigation,
                  styles["navigation-prev"]
                )}
              >
                <Icon className={styles.icon} name="arrow_slider_prev" />
              </div>
              <div
                ref={nextRef}
                className={classNames(
                  styles.navigation,
                  styles["navigation-next"]
                )}
              >
                <Icon className={styles.icon} name="arrow_slider_next" />
              </div>
            </div>
            {isDesktop && <div className={styles.pagination}></div>}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Content022;
